import { useContext } from 'react';

import NotificationsContext from './context';

const useNotifications = () => {
  const context = useContext(NotificationsContext);

  return context;
};

export default useNotifications;
